"use strict";var E;exports.LotteRepeatMode=void 0,(E=exports.LotteRepeatMode||(exports.LotteRepeatMode={})).LOTTE_REPEAT_MODE_INVALID="LOTTE_REPEAT_MODE_INVALID",E.LOTTE_REPEAT_MODE_REVERSE="LOTTE_REPEAT_MODE_REVERSE",E.LOTTE_REPEAT_MODE_RESTART="LOTTE_REPEAT_MODE_RESTART";
//# sourceMappingURL=type.js.map
